<template>
  <div>
    <!-- <div class="tip_msg_cla black_panel_margin_bottom">
      {{ $t('com_log.tipMsg') }}
    </div> -->
    <div class="search-bar-margin-bottom-cla">
      <el-form
        label-position="left"
        :inline="true"
        :model="queryForm"
        class="query-from-cla"
      >
        <el-form-item
          :key="item.key"
          v-for="item of searchOption"
          :label="item.label"
        >
          <el-select
            v-if="item.options"
            clearable
            v-model="item.value"
            :placeholder="item.placeholder"
            :filterable="item.options && item.options.length > 5"
          >
            <el-option
              :key="selectItem.key"
              v-for="selectItem of item.options"
              :label="selectItem.key"
              :value="selectItem.value"
            ></el-option>
          </el-select>

          <el-input
            v-else
            v-model="item.value"
            :placeholder="item.placeholder"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-date-picker
            :clearable="true"
            v-model="queryForm.timeRang"
            range-separator="~"
            start-placeholder
            end-placeholder
            :picker-options="pickerOptions"
            @change="timeOnchage"
            type="datetimerange"
            :default-time="['00:00:00', '23:59:59']"
            format="yyyy-MM-dd HH:mm:ss"
          ></el-date-picker>

          <el-button
            @click.stop="getComlogsFn"
            type="primary"
            icon="el-icon-search"
            >{{ $t('com_log.search') }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="black_panel_margin_bottom">
      <el-table
        v-if="isDevicePage"
        class="com_log_table_cla"
        @row-click="rowClick"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column
          :width="210"
          prop="eventTime"
          :label="$t('com_log.eventTime')"
        >
          <template slot-scope="scope">{{
            scope.row.eventTime | dataFormat('yyyy-MM-dd HH:mm:ss.S')
          }}</template>
        </el-table-column>
        <el-table-column prop="sn" :label="$t('com_log.sn')"></el-table-column>
        <el-table-column
          prop="protocol"
          :width="140"
          :label="$t('com_log.protocol')"
        ></el-table-column>
        <el-table-column
          prop="eventType"
          :width="200"
          :label="$t('com_log.type')"
        ></el-table-column>
        <el-table-column
          :width="290"
          prop="mid"
          :label="$t('com_log.mid')"
        ></el-table-column>
        <el-table-column
          prop="funcName"
          :label="$t('com_log.funcName')"
        ></el-table-column>
        <el-table-column prop="result" :label="$t('com_log.result')">
          <template slot-scope="scope">
            <div>
              <el-tag v-if="scope.row.result === true" type="success">
                {{ $t('com_log.success') }}
              </el-tag>
              <el-tag v-if="scope.row.result === false" type="danger">
                {{ $t('com_log.fail') }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="content" :label="$t('com_log.content')">
          <template slot-scope="scope">
            <div class="myNote">{{ scope.row.content }}</div>
          </template>
        </el-table-column>
      </el-table>

      <el-table
        v-else
        class="com_log_table_cla"
        :data="tableData"
        style="width: 100%"
        @row-click="rowClick"
      >
        <el-table-column
          :width="220"
          prop="eventTime"
          :label="$t('com_log.eventTime')"
        >
          <template slot-scope="scope">{{
            scope.row.eventTime | dataFormat('yyyy-MM-dd HH:mm:ss.S')
          }}</template>
        </el-table-column>
        <el-table-column prop="sn" :label="$t('com_log.sn')"></el-table-column>
        <el-table-column
          prop="protocol"
          :width="60"
          :label="$t('com_log.protocol')"
        ></el-table-column>
        <el-table-column
          prop="eventType"
          :label="$t('com_log.type')"
        ></el-table-column>
        <el-table-column
          prop="mid"
          :width="290"
          :label="$t('com_log.mid')"
        ></el-table-column>
        <el-table-column
          prop="funcName"
          :label="$t('com_log.funcName')"
        ></el-table-column>
        <el-table-column
          prop="result"
          :label="$t('com_log.result')"
          width="100"
        >
          <template slot-scope="scope">
            <div>
              <el-tag v-if="scope.row.result === true" type="success">
                {{ $t('com_log.success') }}
              </el-tag>
              <el-tag v-if="scope.row.result === false" type="danger">
                {{ $t('com_log.fail') }}
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="content"
          :label="$t('common.action')"
          width="100"
        >
          <template slot-scope="scope">
            <span class="btn-text-cla" @click.stop="rowClick(scope.row)">{{
              $t('common.details')
            }}</span>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!listOver" class="load-more-cla">
        <el-button
          @click="loadMore"
          :loading="loading"
          class="load-more-btn-cla"
          type="text"
          >{{ $t('com_log.loadMore') }}</el-button
        >
      </div>
    </div>

    <el-drawer
      :with-header="false"
      :visible.sync="drawer"
      direction="rtl"
      size="35%"
    >
      <el-tabs
        @tab-click="tabClick"
        class="com_log_tabs_cla"
        v-model="activeName"
        type="card"
      >
        <el-tab-pane :label="$t('com_log.content')" name="first">
          <div style="text-align: right;">
            <el-button
              v-if="JSON.stringify(currentRow)"
              class="logocontent"
              :data-clipboard-text="JSON.stringify(currentRow)"
              @click="copy('.logocontent')"
            >
              {{ $t('apiLog.copy') }}
            </el-button>
          </div>
          <ul
            style="padding:5px;margin:0px"
            class="associatedLog_ul_cla"
            v-if="currentRow !== ''"
          >
            <!-- <li>
              <label>{{ $t('com_log.eventTime') }}</label>
              <div class="value_cla">{{ currentRow.id }}</div>
            </li> -->
            <li>
              <label>{{ $t('com_log.sn') }}</label>
              <div class="value_cla">{{ currentRow.sn }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.mid') }}</label>
              <div class="value_cla">{{ currentRow.mid }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.eventTime') }}</label>
              <div class="value_cla">{{ currentRow.eventTime }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.protocol') }}</label>
              <div class="value_cla">{{ currentRow.protocol }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.type') }}</label>
              <div class="value_cla">{{ currentRow.eventType }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.funcName') }}</label>
              <div class="value_cla">{{ currentRow.funcName }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.result') }}</label>
              <div class="value_cla">
                {{
                  currentRow.result === true
                    ? $t('com_log.success')
                    : $t('com_log.fail')
                }}
              </div>
            </li>
            <li>
              <label>{{ $t('com_log.content') }}</label>
              <div class="value_cla">
                <json-viewer
                  :expand-depth="10"
                  :value="currentRow.content"
                ></json-viewer>
              </div>
            </li>
          </ul>
        </el-tab-pane>

        <el-tab-pane :label="$t('com_log.associatedLog')" name="second">
          <div style="text-align: right;">
            <el-button
              v-if="this.associatedLog !== ''"
              class="associatedLog"
              :data-clipboard-text="JSON.stringify(associatedLog)"
              @click="copy('.associatedLog')"
            >
              {{ $t('apiLog.copy') }}
            </el-button>
          </div>

          <ul
            style="padding:5px;margin:0px"
            class="associatedLog_ul_cla"
            v-if="this.associatedLog !== ''"
          >
            <li>
              <label>{{ $t('com_log.eventTime') }}</label>
              <div class="value_cla">{{ associatedLog.eventTime }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.sn') }}</label>
              <div class="value_cla">{{ associatedLog.sn }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.protocol') }}</label>
              <div class="value_cla">{{ associatedLog.protocol }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.type') }}</label>
              <div class="value_cla">{{ associatedLog.eventType }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.mid') }}</label>
              <div class="value_cla">{{ associatedLog.mid }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.funcName') }}</label>
              <div class="value_cla">{{ associatedLog.funcName }}</div>
            </li>
            <li>
              <label>{{ $t('com_log.result') }}</label>
              <div class="value_cla">
                {{
                  associatedLog.result === true
                    ? $t('com_log.success')
                    : $t('com_log.fail')
                }}
              </div>
            </li>
            <li>
              <label>{{ $t('com_log.content') }}</label>
              <div class="value_cla">
                <json-viewer
                  :expand-depth="10"
                  class="associatedLog_json_cla"
                  v-if="this.associatedLog.content !== ''"
                  :value="convertToJson(associatedLog.content)"
                ></json-viewer>
              </div>
            </li>
          </ul>
          <div style="height:50px;line-height:50px;text-align:center" v-else>
            {{ $t('common.noData') }}
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
  </div>
</template>
<script>
import {
  getComBasic,
  getComlogs,
  getComRelevant
} from '@/services/communicationLogApi.js'
import { dateFormat, getCurrentDateStartAndEndTime } from '@/utils/utils.js'
import pickerOptions from '@/utils/pickerOptions.js'
import JsonViewer from 'vue-json-viewer'
import Clipboard from 'clipboard'
export default {
  data() {
    return {
      queryForm: {
        timeRang: getCurrentDateStartAndEndTime()
      },
      loadingInstance: null,
      secondTabloading: null,
      loading: false,
      drawer: false,
      activeName: 'first',
      currentRow: '',
      tableData: [],
      pickerOptions: pickerOptions(this),
      lookupFields: [],
      valueOption: '',
      scrollId: '',
      associatedLog: '',
      listOver: true,
      searchOption: []
    }
  },
  props: {
    isDevicePage: {
      type: Boolean,
      default: false
    },
    devSn: {
      type: String,
      default: ''
    },
    contentHeight: {
      type: Number,
      default: 800
    }
  },
  mounted() {
    this.getComBasicFn()
    this.getComlogsFn()
  },
  components: { JsonViewer },
  watch: {
    devSn(val) {
      this.getComlogsFn()
    }
    // 'queryForm.field': {
    //   handler: function(val, oVal) {
    //     if (val) {
    //       this.queryForm.value = ''
    //       this.lookupFields.some(item => {
    //         if (val === item.key) {
    //           if (item.options === undefined) {
    //             this.valueOption = ''
    //           } else {
    //             let option = item.options
    //             let keys = Object.keys(option)
    //             let optionArray = []
    //             keys.forEach(item => {
    //               optionArray.push({
    //                 key: option[item],
    //                 value: item
    //               })
    //             })
    //             this.valueOption = optionArray
    //           }
    //           return true
    //         }
    //       })
    //     } else {
    //       this.valueOption = ''
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    timeOnchage(val) {
      this.timeRang = val
    },
    getComBasicFn() {
      getComBasic()
        .then(data => {
          if (data.code === '00000000') {
            let lookupFields = data.payload.data.lookupFields
            let searchOption = []
            let placeholderMap = {
              sn: this.$t('com_log.inputSn'),
              mid: this.$t('com_log.inputMid'),
              protocol: this.$t('com_log.selectProtocol'),
              eventType: this.$t('com_log.selectEventType'),
              funcName: this.$t('com_log.selectFuncName'),
              result: this.$t('com_log.selectResult')
            }
            lookupFields.forEach(item => {
              if (
                this.devSn &&
                (item.key === 'sn' || item.key === 'protocol')
              ) {
                return
              }
              let configItem = {
                label: item.value,
                key: item.key,
                value: '',
                placeholder: placeholderMap[item.key]
              }
              if (item.options) {
                let option = item.options
                let keys = Object.keys(option)
                let optionArray = []
                keys.forEach(item => {
                  optionArray.push({
                    key: option[item],
                    value: item
                  })
                })
                configItem.options = optionArray
              }
              searchOption.push(configItem)
            })
            this.searchOption = searchOption
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage(e.message)
        })
    },
    rowClick(row) {
      let content = row.content
      row.content = this.convertToJson(content)
      let temp = JSON.parse(JSON.stringify(row))

      temp.startTime = temp.eventTime
      temp.eventTime = dateFormat(
        new Date(temp.eventTime),
        'yyyy-MM-dd HH:mm:ss.S'
      )
      this.currentRow = temp
      this.associatedLog = ''
      this.drawer = true
      this.activeName = 'first'
    },

    convertToJson(str) {
      try {
        let obj = JSON.parse(str)
        if (typeof obj === 'object') {
          return JSON.parse(str, (key, value) => {
            if (key === 'eventTime') {
              return dateFormat(new Date(value))
            }
            if (value instanceof Array) {
              return value
            }
            return this.convertToJson(value)
          })
        } else {
          return str
        }
      } catch (error) {
        return str
      }
    },

    getComlogsFn() {
      let params = {
        lookupFields: {}
      }

      if (this.queryForm.field && this.queryForm.value) {
        params.lookupFields[this.queryForm.field] = this.queryForm.value
      }

      this.searchOption.forEach(item => {
        if (item.value) {
          params.lookupFields[item.key] = item.value
        }
      })
      if (this.isDevicePage) {
        params.lookupFields.sn = this.devSn
      }

      if (this.scrollId) {
        params.lastScrollId = this.scrollId
      }
      if (!!this.queryForm.timeRang && this.queryForm.timeRang.length === 2) {
        let start = this.queryForm.timeRang[0]
        start.setMilliseconds(0)
        let end = this.queryForm.timeRang[1]
        end.setMilliseconds(999)
        params.startTime = start.getTime()
        params.endTime = end.getTime()
      }
      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })

      getComlogs(JSON.parse(JSON.stringify(params)))
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.data
            this.tableData = result.logs
            this.scrollId = result.scrollId
            this.listOver = result.listOver
          } else {
            this.errorMessage(data.message)
          }
          this.loadingInstance.close()
        })
        .catch(e => {
          this.loadingInstance.close()
          this.errorMessage(e.message)
        })
    },
    loadMore() {
      this.loading = true
      this.loadingInstance = this.$loading({
        lock: true,
        fullscreen: true,
        text: '',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      getComlogs({
        scrollId: this.scrollId
      })
        .then(data => {
          if (data.code === '00000000') {
            let result = data.payload.data
            this.listOver = result.listOver
            if (!result.listOver) {
              this.tableData.push(...result.logs)
              this.scrollId = result.scrollId
            }
          } else {
            this.errorMessage(data.message)
          }
          this.loading = false
          this.loadingInstance.close()
        })
        .catch(e => {
          this.loading = false
          this.loadingInstance.close()
          this.errorMessage(e.message)
        })
    },

    copy(select) {
      var clipboard = new Clipboard(select)
      clipboard.on('success', e => {
        this.$notify({
          title: this.$t('apiLog.success'),
          message: this.$t('apiLog.copySucess'),
          type: 'success'
        })
        clipboard.destroy() // 释放内存
      })
      clipboard.on('error', e => {
        this.$notify({
          title: this.$t('apiLog.fail'),
          message: this.$t('apiLog.copyError'),
          type: 'warning'
        })
        clipboard.destroy() // 释放内存
      })
    },
    tabClick(tab) {
      if (tab.name === 'second') {
        if (this.associatedLog !== '') {
          return false
        }
        this.secondTabloading = this.$loading({
          target: '.el-drawer__body',
          text: '',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let row = this.currentRow
        let params = {
          id: row.id,
          mid: row.mid,
          sn: row.sn,
          startTime: row.startTime - 60000
        }
        getComRelevant(params)
          .then(data => {
            this.associatedLog = ''
            if (data.code === '00000000') {
              this.associatedLog =
                data.payload.data === undefined ? '' : data.payload.data
              if (this.associatedLog && this.associatedLog.eventTime) {
                this.associatedLog.eventTime = dateFormat(
                  new Date(this.associatedLog.eventTime)
                )
              }
            } else {
              this.errorMessage(data.message)
            }
            this.secondTabloading.close()
          })
          .catch(e => {
            this.errorMessage(e.message)
          })
      }
    }
  }
}
</script>

<style scoped lang="less">
.com_log_tabs_cla {
  /deep/ .jv-code {
    padding: 0px;
  }
}
.com_log_table_cla {
  /deep/.el-table__row {
    :hover {
      cursor: pointer;
    }
  }
}
.associatedLog_ul_cla {
  width: 100%;
  li {
    list-style: none;
    line-height: 30px;
    display: flex;
    border-bottom: 1px solid #607d8b30;
    label {
      width: 110px;
      display: inline-block;
      position: relative;
      margin-right: 5px;
      font-weight: 600;
      &::before {
        content: ':';
        position: absolute;
        left: 100px;
      }
    }
    .value_cla {
      width: calc(100% - 100px);
    }
  }
}
.query-from-cla {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  align-items: baseline;
}
.tip_msg_cla {
  margin-top: 5px;
  background-color: #e5f0ff;
  padding: 10px;
  border: 1px solid #7ace43;
}
.btn-text-cla {
  cursor: pointer;
}
/deep/ .com_log_tabs_cla {
  .el-tabs__header {
    margin-bottom: 5px;
  }
  .el-tabs__content {
    padding: 5px 10px;
    pre {
      margin: 0px;
    }
  }
}

.myNote {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.load-more-cla {
  padding: 5px;
  text-align: center;
  .load-more-btn-cla {
    color: #909399;
    :hover {
      color: #7ace43;
    }
  }
}
.search-bar-margin-bottom-cla {
  .el-form-item {
    display: flex;
    flex-wrap: nowrap;
    margin-bottom: 20px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/communicationLog.vue